<template>
  <div
    class="sharer sharer-folding"
    :class="[
      {
        'sharer--opened': opened
      }
    ]"
  >
    <SharerBase class="sharer__list _list" v-bind="$props" />
    <div class="sharer__button" @click="toggle" data-cursor="hover">
      <div class="_icon">
        <div class="_icon -share">
          <svg-use size="48" icon="share"></svg-use>
        </div>
        <div class="_icon -close"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SharerPropsMixin from "../mixins/SharerPropsMixin";
import SharerBase from "./SharerBase";

export default {
  mixins: [SharerPropsMixin],
  components: {
    SharerBase
  },
  data() {
    return {
      opened: false
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
      this.$emit("toggleSharer", this.opened);
    }
  }
};
</script>

<style lang="scss">
$block: ".sharer";
.sharer-folding {
  position: relative;
  width: 49px;
  height: 49px;
  pointer-events: all;
  #{$block}__item {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    transition: all 0.25s 0s ease;
    transform: translateX(0) scale(0.7);
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #777;
      border-radius: 50%;
    }
    &.-vk {
      ._icon {
        width: 50%;
      }
    }
    &.-fb {
      ._icon {
        width: 48%;
      }
    }
    &.-ok {
      ._icon {
        width: 47%;
      }
    }
    &.-tw {
      ._icon {
        width: 48%;
        svg {
          transform: translateX(1px);
        }
      }
    }
    &.-tg {
      ._icon {
        width: 43%;
        svg {
          transform: translateX(-1px);
        }
      }
    }
    &:nth-child(1) {
      transition-delay: 0s;
    }
    &:nth-child(2) {
      transition-delay: 0.05s;
    }
    &:nth-child(3) {
      transition-delay: 0.1s;
    }
    &:nth-child(4) {
      transition-delay: 0.15s;
    }
    &:nth-child(5) {
      transition-delay: 0.2s;
    }
  }
  #{$block}__icon {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  #{$block}__button {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    &:before {
      content: " ";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #555;
      transition: all 0.25s 0s ease;
    }

    ._icon {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      margin: auto;
      transition: all 0.25s 0s ease;
      &.-close {
        width: 40%;
        height: 40%;
        opacity: 0;
        transform: rotate(-145deg);
        &:before,
        &:after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          margin: auto;
          width: 100%;
          height: 3px;
          background-color: currentColor;
          border-radius: 3px;
        }
        &:after {
          transform: rotate(90deg);
        }
      }
    }

    &:hover {
      &:before {
        transform: scale(1.1);
      }
    }
  }
  &#{$block}--opened {
    #{$block}__button {
      ._icon {
        &.-share {
          opacity: 0;
          transform: rotate(145deg);
        }
        &.-close {
          opacity: 1;
          transform: rotate(45deg);
        }
      }
    }
    #{$block}__item {
      &:nth-child(1) {
        transform: translateX(calc(-100% - 10px)) scale(1);
        transition-delay: 0.25s;
      }
      &:nth-child(2) {
        transform: translateX(calc(-200% - 20px)) scale(1);
        transition-delay: 0.2s;
      }
      &:nth-child(3) {
        transform: translateX(calc(-300% - 30px)) scale(1);
        transition-delay: 0.15s;
      }
      &:nth-child(4) {
        transform: translateX(calc(-400% - 40px)) scale(1);
        transition-delay: 0.1s;
      }
      &:nth-child(5) {
        transform: translateX(calc(-500% - 50px)) scale(1);
        transition-delay: 0.05s;
      }
    }
  }
  &[colored] {
    #{$block}__item {
      &.-vk {
        &:before {
          background-color: $color_vk;
        }
      }
      &.-fb {
        &:before {
          background-color: $color_fb;
        }
      }
      &.-ok {
        &:before {
          background-color: $color_ok;
        }
      }
      &.-tw {
        &:before {
          background-color: $color_tw;
        }
      }
      &.-tg {
        &:before {
          background-color: $color_tg;
        }
      }
    }
  }
  &[hoverScale] {
    #{$block}__item {
      &:before {
        transform: translate3d(0, 0, 0);
        transition: all 0.25s 0s ease;
      }
      &:hover:before {
        transform: scale(1.1);
      }
    }
  }
}
</style>
